<div class="close-button" (click)="closeDialog()" [style.backgroundColor]="color"></div>
<div class="tag" [style.backgroundColor]="color" [style]="{'--color': color}">
  {{ "MATCHING_GIFT_DIALOG.title_matching_gift_dialog" | translate }}
</div>

<div class="scrollable" [style]="{'--color': color, '--rgba-color': colorHelper.hexToRGBA(color, 0.7)}">
  <div [ngClass]="{'dont-display' : currentStep !== 1}">
    <div class="heading">
      {{ companyName }} {{ "MATCHING_GIFT_DIALOG.subtitle1_matching_gift_dialog" | translate }} {{ multiplicationFactor }}
    </div>
    <div class="message-blue" *ngIf="premiumNumber >= 1">{{ companyName }} {{ "MATCHING_GIFT_DIALOG.subtitle1_matching_gift_dialog" | translate }} {{ premiumFactor }} {{ "MATCHING_GIFT_DIALOG.subtitle2_matching_gift_dialog" | translate }} {{ premiumNumber }} {{ "MATCHING_GIFT_DIALOG.subtitle3_matching_gift_dialog" | translate }}</div>

    <app-donation-amount-selector
      [brandColor]="color"
      (amountSelected$)="onSelectAmount($event)"
      (formValid$)="onAmountFormValidityChanges($event)">
    </app-donation-amount-selector>

    <div [ngClass]="{'invisible' : !isAmountFormValid}" class="after-tax">
      <span>{{ selectedAmount | multiply : multiplicationFactor - 1 }}€</span> {{ "MATCHING_GIFT_DIALOG.given_matching_gift_dialog" | translate }} {{ companyName }}
    </div>

    <div class="button-block first-button">
      <button (click)="nextStep()" [disabled]="!isAmountFormValid" class="yellow sans-serif" [style]="{'--color': color}">
        {{ "SUBSCRIPTION.next_subscription" | translate }} <img loading="lazy" src="/assets/icons/arrow-right-white.svg" alt="arrow">
      </button>
    </div>

    <div class="yellow-block" [style]="{'--color': getRGBAColor()}">
      <div class="guaranties">
        <div class="heading">
          {{ "EDIT_SUBSCRIPTION.guaranteed_editsubscription" | translate }}
          <div class="guarantee-image" [innerHTML]="getSvgImage()"></div>
        </div>
        <ul>
          <li>{{ "EDIT_SUBSCRIPTION.secured_editsubscription" | translate }}</li>
          <li>{{ "EDIT_SUBSCRIPTION.trusted_editsubscription" | translate }}</li>
          <li>{{ "MATCHING_GIFT_DIALOG.receipt_matching_gift_dialog" | translate }}</li>
        </ul>
      </div>
      <div class="includes">
        <div class="heading">{{ "EDIT_SUBSCRIPTION.includes_editsubscription" | translate }}</div>
        <ul>
          <li>{{ "EDIT_SUBSCRIPTION.fun_editsubscription" | translate }}</li>
          <li>{{ "EDIT_SUBSCRIPTION.access_editsubscription" | translate }}</li>
          <li>{{ "EDIT_SUBSCRIPTION.data_editsubscription" | translate }}</li>
        </ul>
      </div>
    </div>
  </div>

  <ng-template [ngIf]="currentStep === 2">
    <div class="subs-projects-block">
      <div class="subs-amount" [style]="{'--color': getRGBAColor()}">
        <div class="heading">{{ "MATCHING_GIFT_DIALOG.give_matching_gift_dialog" | translate }}</div>
        <div class="amount">{{ selectedAmount }} €</div>
        <div class="after-tax"><span>{{ selectedAmount | deduct : 'France' | number : '1.2-2' }}€</span> {{ "SUBSCRIPTION.after_subscription" | translate }}</div>
        <div class="edit" (click)="previousStep()">{{ "SUBSCRIPTION.edit_subscription" | translate }}</div>
        <div class="amount-wrapper" [style]="{'--color': color}">
          <div class="text-amount">
            {{ companyName }} {{ "MATCHING_GIFT_DIALOG.also_matching_gift_dialog" | translate }}
          </div>
          <div class="amount-amount">
            {{ selectedAmount | multiply : multiplicationFactor - 1 }} €
          </div>
        </div>
      </div>
    </div>

    <div class="heading heading-card-info">{{ "EDIT_PAYMENT.enter_editpayment" | translate }}</div>

    <div class="card-info-block" [formGroup]="cardInfoGroup">
      <div class="card-info">
        <div>
          <label class="email-label">{{ "MATCHING_GIFT_DIALOG.email_matching_gift_dialog" | translate }}</label>
          <input class="control email-input" formControlName="email" placeholder="john.doe@gmail.com" type="email">
        </div>
        <ng-container *ngIf="!this.cardInfoGroup.invalid || this.cardInfoGroup.untouched">
          <div class="email-text">
            {{ "MATCHING_GIFT_DIALOG.email_text1_matching_gift_dialog" | translate }}
            <br>{{ "MATCHING_GIFT_DIALOG.email_text2_matching_gift_dialog" | translate }}
          </div>
        </ng-container>
        <ng-container *ngIf="this.cardInfoGroup.invalid && this.cardInfoGroup.touched">
          <div class="email-error-text">
            <small *ngIf="email.errors?.required && email.touched"
            >{{ "LOG_IN_PAGE.email_required_login" | translate }}</small>
            <small *ngIf="email.errors?.pattern && email.touched"
            >{{ "LOG_IN_PAGE.email_structure_login" | translate }}</small>
          </div>
        </ng-container>
        <app-stripe-card-form
          (formValid$)="onDonationFormValidityChanges($event)"
          (paymentStatus$)="onDonationProcessCompletes($event)"
          [donationType]="donationType.NO_KPI_MATCHING_GIFT"
          [externalFormValidator]="this.cardInfoGroup.valid"
          [hasExternalValidation]="true"
          [isUnloggedUser]="true"
          [paymentButtonClicked]="paymentButtonClicked"
        >
        </app-stripe-card-form>
      </div>
      <div class="we-accept">
        <div>{{ "EDIT_PAYMENT.accept_editpayment" | translate }}</div>
        <span class="img-wrapper first"><img loading="lazy" src="/assets/icons/mastercard.png" alt="mastercard"></span>
        <span class="img-wrapper"><img loading="lazy" src="/assets/icons/visa.png" alt="visa"></span>
        <div>{{ "EDIT_PAYMENT.stripe_editpayment" | translate }}</div>
      </div>
    </div>

    <div class="button-block">
      <button (click)="onPaymentButtonClick()"
              [disabled]="!this.isDonationFormValid"
              [style]="{'--color': color}"
              class="yellow sans-serif">
        {{ "SUBSCRIPTION.finalize_subscription" | translate }}
      </button>
    </div>
  </ng-template>
</div>
